<ion-item
  lines="full"
  class="ion-no-padding"
  [routerLink]="
    orderItem.order.referenceKey
      ? ['/fleet/orders/combined/edit', orderItem.order.referenceKey]
      : null
  "
  [state]="{ orderItem: orderItem }"
>
  <ion-button
    *ngIf="!orderItem.order.combiNumber"
    id="order-item-{{ orderItem.id }}"
    fill="clear"
    color="primary"
    class="ion-no-padding"
    size="default"
    slot="start"
    [disabled]="!!orderItem.order.combiNumber"
  >
    <ion-icon slot="icon-only" color="primary" name="ellipsis-vertical" />
  </ion-button>

  <div class="details-container ion-margin-top ion-margin-bottom">
    <div class="row">
      <div class="intinerary-container">
        <div class="internary">
          <ng-container *ngIf="orderItem.order.referenceKey">
            {{ orderItem.order.referenceKey }}
          </ng-container>
          <ion-text class="referenceKey">
            <strong>{{ orderItem.order.registration }}</strong>
          </ion-text>
        </div>
        <div class="intinerary">
          <ion-text>{{ orderItem.order.origins[0].displayName }}</ion-text>
          <ion-icon name="arrow-forward-outline" color="medium" />
          <ion-text>{{ orderItem.order.destinations[0].displayName }}</ion-text>
        </div>
      </div>

      <div>
        <ion-text>
          {{ orderItem.order.totalAmount | currency: 'EUR' }}
        </ion-text>
      </div>
    </div>

    <ion-grid class="ion-no-padding grid">
      <ion-row>
        <ion-col size="3">
          <app-date-chip
            [dateString]="startDate()"
            [label]="'movacarfleet_order_earliest_pickup' | translate"
          />
        </ion-col>

        <ion-col size="3">
          <app-date-chip
            [dateString]="endDate()"
            [label]="'movacarfleet_order_latest_dropoff' | translate"
          />
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col
          size="3"
          *ngIf="files().length > 0"
          class="attach-icon-container"
          [class.text-danger]="hasUploadErrors()"
        >
          <ion-icon class="attach-icon" size="large" name="attach-outline">
          </ion-icon>
          <p class="attach-icon-text">({{ files().length }})</p>
        </ion-col>

        <ion-col size="3">
          <ion-chip
            class="status-chip"
            *ngIf="orderItem.order.status"
            [color]="getStatusClass(orderItem.order.status || '')"
          >
            <ion-icon name="document-text-outline" />
            {{ getStatusTranslate(orderItem.order.status || '') | translate }}
          </ion-chip>
        </ion-col>

        <ion-col size="3">
          <ion-chip
            class="status-chip"
            *ngIf="orderItem.order.deliveryStatus"
            [color]="
              getDeliveryStatusClass(orderItem.order.deliveryStatus || '')
            "
          >
            <ion-icon name="car-outline" />
            {{
              getDeliveryStatusTranslate(orderItem.order.deliveryStatus || '')
                | translate
            }}
          </ion-chip>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-item>

<ion-popover #popover trigger="order-item-{{ orderItem.id }}">
  <ng-template>
    <ion-list lines="full">
      <ion-item
        [routerLink]="['/fleet/orders/combined/edit']"
        [state]="{ orderItem: orderItem }"
        button
        disaled
        (click)="dismissOptions()"
      >
        <ion-icon name="pencil-outline" slot="start" />
        <ion-text>Edit</ion-text>
      </ion-item>

      <ion-item (click)="copyOrder()" button>
        <ion-icon name="copy-outline" slot="start" />
        <ion-text>Copy</ion-text>
      </ion-item>

      <ion-item (click)="removeOrder()" button>
        <ion-icon name="trash-outline" slot="start" color="danger" />
        <ion-text color="danger">Delete</ion-text>
      </ion-item>
    </ion-list>
  </ng-template>
</ion-popover>
